import FactBadge from './FactBadge';

export default FactBadge;
